module.exports = __webpack_public_path__ + "img/zx.c5d7e042.png";